import { observer } from 'mobx-react-lite';
import payeaseStore from '../../stores/payease.store';
import { formatPrice } from '../../payease.utils';
import { PayEaseModal } from '../ui/payease-modal/payease-modal';
import { SelectableCard } from '../ui/selectable-card/selectable-card';
import './option-picker-modal.scss';

export const OptionPickerModal = observer(() => {
  const pass = payeaseStore.pickerPass;

  return (
    <PayEaseModal
      open={!!payeaseStore.optionPickerPassId}
      onClose={() => payeaseStore.closeOptionPicker()}
      width={520}
      title={pass?.name}
      subtitle="Select a vehicle option to continue.">
      <div className="option-picker__list">
        {pass?.options.map((option) => (
          <SelectableCard key={option.id} className="option-picker__option" onClick={() => payeaseStore.handleOptionPick(option.id)}>
            <span className="option-picker__option-label">{option.label}</span>
            <span className="option-picker__option-price">{formatPrice(option.price)}</span>
          </SelectableCard>
        ))}
      </div>
    </PayEaseModal>
  );
});
